module.exports = {
      id: "plus-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "images/sprites/ui.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }